import { Component, EventEmitter, input, Output } from '@angular/core';

import { LiquidPageAnnotation, LiquidTooltipMode } from '../liquid-page.models';

@Component({
  selector: 'meta-liquid-tooltip',
  templateUrl: './liquid-tooltip.component.html',
  styleUrls: ['./liquid-tooltip.component.scss']
})
export class LiquidTooltipComponent {
  
  @Output() createHighlight: EventEmitter<{ color: string; }> = new EventEmitter();
  @Output() createNote: EventEmitter<void> = new EventEmitter();
  @Output() createLink: EventEmitter<void> = new EventEmitter();
  @Output() deleteAnnotation: EventEmitter<LiquidPageAnnotation> = new EventEmitter();
  @Output() updateAnnotation: EventEmitter<LiquidPageAnnotation> = new EventEmitter();
  @Output() openAnnotation: EventEmitter<LiquidPageAnnotation> = new EventEmitter();

  $coords = input.required<{ top: number; left: number; }>({ alias: 'coords' });
  $annotation = input<LiquidPageAnnotation | undefined>(undefined, { alias: 'annotation' });
  $mode = input.required<LiquidTooltipMode>({ alias: 'mode' });

  updateHighlight(color: string) {
    const cv = this.$annotation();
    if (!cv) {
      return;
    }
    cv.color = color;
    cv.data.color = color;
    this.updateAnnotation.emit(cv);
  }
}